import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
  // toggle = false;
  formularioBarraPesquisa: FormGroup;
  stringBusca: string;

  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.formularioBarraPesquisa = new FormGroup({
      stringBusca: new FormControl(null),
    });
  }

  onPesquisar() {
    this.stringBusca = this.formularioBarraPesquisa.get('stringBusca').value;
    this.router.navigate(['/pesquisa'], {
      queryParamsHandling: 'merge',
      queryParams: { query: this.stringBusca, pagina: 1 },
    });
    this.formularioBarraPesquisa.reset();
  }

  reloadPage() {
    window.location.reload();
  }
}
